<ion-app>
  
  <div *ngIf="environment.environment =='development'"
    class="absolute top-0 left-0 right-0 bg-red-600 text-white z-[40000] text-center">Testsystem</div>
  <p-toast />
  <p-confirmdialog />
  <p-dialog />
  <ion-router-outlet></ion-router-outlet>
</ion-app>